import * as React from 'react';
import { CmdTooltip } from '@commander-services/gui-components';
import TooltipComponent from '../../TooltipComponent';

interface ITextareaProps {
  name: string;
  label: string;
  rows?: number;
  id: string;
  placeholder?: string;
  readonly?: boolean;
  tooltip?: string;
  isChangeDetail?: string;
  disabled?: boolean;
  value?: string;
}

export default function Textarea(props: ITextareaProps) {
  return (
    <div className={`${'form-group'}`}>
      <div className="row">
        <label className="col-12 col-lg-3 form-label">{props.label}</label>
        <div className="col-12 col-lg-9">
          {props.isChangeDetail !== undefined ? (
            <div
              style={{
                background: 'rgb(242, 242, 242)',
                border: '1px solid rgb(221, 221, 221)',
                minHeight: '84px',
                color: '#494949',
                borderRadius: '4px',
                padding: '7px',
              }}
            >
              <TooltipComponent
                id={props.id}
                firstItems={true}
                width="300px"
                overlay={<div style={{ color: '#fff' }}>{props.isChangeDetail || '-'}</div>}
              >
                <span
                  style={{
                    background: 'rgb(61, 114, 200)',
                    padding: '2px 10px 3px 10px',
                    borderRadius: '11px',
                    opacity: 0.3,
                    color: 'rgb(0, 0, 0)',
                  }}
                >
                  {props.value}
                </span>
              </TooltipComponent>
            </div>
          ) : (
            <textarea
              id={props.id}
              data-cy={`form-text-area-${props.name}`}
              name={props.name}
              rows={props.rows}
              placeholder={props.placeholder || ''}
              readOnly={props.readonly}
              className="form-control"
              title={props.tooltip || ''}
              disabled={props.disabled}
              style={props.disabled ? { cursor: 'not-allowed', color: '#999' } : {}}
              value={props.value}
            />
          )}
        </div>
      </div>
    </div>
  );
}
